<template>
  <Suspense>
    <WizCo v-bind="$attrs" />
    <template #fallback>
      <LoadingSpinner />
    </template>
  </Suspense>
</template>

<script setup>
import WizCo from './WizCo.vue'
import LoadingSpinner from './components/LoadingSpinner.vue'
import { useWizcoStore } from './stores/wizco'
import { watch, toRaw } from 'vue'

const emit = defineEmits(['trackingEvent', 'stepChange', 'forwardRequest'])
const wizco = useWizcoStore()
watch(
  () => wizco.trackingEvents,
  () => {
    emit('trackingEvent', {
      eventNames: toRaw(wizco.trackingEvents),
      wizardVersion: wizco.settings.content.version,
      wizardName: wizco.settings.content.name
    })
  }
)
watch(
  () => wizco.activeStepUuid,
  (newStepUuid, oldStepUuid) => {
    if (oldStepUuid) {
      emit('stepChange', newStepUuid)
    }
  }
)
watch(
  () => wizco.forwardingUrlObject,
  (forwardingUrlObject) => {
    if (forwardingUrlObject.linktype) {
      emit('forwardRequest', toRaw(forwardingUrlObject))
    }
  }
)
</script>
